module.exports = "/_next/static/images/c631643d68eeea252de42abb64dee9cc-purple-pig-icon.svg";